import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useSavedViewStore } from '../..';
import { useGeoJSONFitBound } from '../../hooks/useFitBounds';
import useIsHalfScreenMap from '../../hooks/useIsHalfScreenMap';
import commonStyles from '../Common.module.css';

function SavedViewPreview() {
    const savedViewStore = useSavedViewStore();
    const isHalfScreenMap = useIsHalfScreenMap();
    const { previewingSavedView } = savedViewStore;
    useGeoJSONFitBound(previewingSavedView?.viewState.focusArea)

    useEffect(() => {
        const discardSavedViewPreview = () => savedViewStore.discardSavedViewPreview();

        window.addEventListener("pagehide", discardSavedViewPreview);
        return () => window.removeEventListener("pagehide", discardSavedViewPreview);
    }, []);

    if (!savedViewStore.previewingSavedView) return null;

    return (
        <div className={isHalfScreenMap ? commonStyles.halfWidthOnMapPanel : commonStyles.onMapPanel}>
            Preview Saved View {savedViewStore.previewingSavedView.name}
            <DoneIcon
                className={commonStyles.clickableIcon}
                onClick={() => savedViewStore.applySavedViewPreview()}
            />
            <CloseIcon
                className={commonStyles.clickableIcon}
                onClick={() => savedViewStore.discardSavedViewPreview()}
            />
        </div>
    );
};

export default observer(SavedViewPreview);
